<!--Text-->
<template>
  <div class="task">
    <TaskCounter :block="block"
                 :counter="counter"
                 ref="taskcounter" />
    <div class="slide__text st__preface st__input"
         v-if="block.content.descr"
         v-html="block.content.descr"></div>
    <StudentTaskText :block="block"/>
  </div>
</template>

<script>
import TaskCounter from "@/views/parts/constructor/parts/TaskCounter"
import StudentTaskText from "@/views/parts/constructor/parts/StudentTaskText"

export default {
  components: {
    StudentTaskText,
    TaskCounter
  },
  props: {
    host: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: "preview"
    },
    block: {
      type: Object,
      default: null
    },
    counter: {
      type: String,
      default: null
    },
    ind: {},
  },
  mounted() {
    this.$emit('solved', true, [])
  }
}
</script>





